"use strict";

exports.__esModule = true;
exports.NotificationsIcon = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _Theme = require("../../Theme");
var _NotificationsIconContext = require("./NotificationsIconContext");
var _reactNotificationBadge = _interopRequireDefault(require("react-notification-badge"));
var _Core = require("../../Core");
var _styles = require("./styles");
var _NotificationsPanel = require("./NotificationsPanel");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var SCALE_EFFECT = ["scale(1.0, 1.0)", "scale(0.75, 0.75)"];
var NotificationsIcon = exports.NotificationsIcon = function NotificationsIcon() {
  var _useContext = (0, _react.useContext)(_Core.TranslatorContext),
    translate = _useContext.translate;
  var notificationsIconContext = (0, _react.useContext)(_NotificationsIconContext.NotificationsIconContext);
  var _ref = notificationsIconContext ? notificationsIconContext : {},
    _ref$notifications = _ref.notifications,
    notifications = _ref$notifications === void 0 ? [] : _ref$notifications,
    readAllNotifications = _ref.readAllNotifications;
  var _useState = (0, _react.useState)(false),
    isOpen = _useState[0],
    setOpen = _useState[1];
  var _useState2 = (0, _react.useState)(0),
    unreadCount = _useState2[0],
    setUnreadCount = _useState2[1];
  (0, _react.useEffect)(function () {
    if (notifications) {
      var count = notifications.filter(function (_ref2) {
        var read = _ref2.read;
        return !read;
      }).length;
      setUnreadCount(count);
    }
  }, [notifications]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.Popover, {
    className: (0, _Theme.val)("NavbarBackgroundTheme"),
    position: _core.Position.BOTTOM_RIGHT,
    canEscapeKeyClose: true,
    isOpen: isOpen,
    enforceFocus: false,
    onClose: function onClose() {
      return setOpen(false);
    },
    shouldDismissPopover: false,
    content: /*#__PURE__*/_react["default"].createElement(_styles.NotificationsWrapper, {
      "data-testid": "NotificationsIcon.Wrapper"
    }, /*#__PURE__*/_react["default"].createElement(_styles.NotificationsToolbar, {
      "data-testid": "NotificationsIcon.Toolbar.Wrapper"
    }, /*#__PURE__*/_react["default"].createElement(_Core.LeftToolbarContent, null, /*#__PURE__*/_react["default"].createElement(_Core.Heading, null, translate("NotificationsIcon.toolbar.Notifications", "Messages"))), /*#__PURE__*/_react["default"].createElement(_Core.RightToolbarContent, null, /*#__PURE__*/_react["default"].createElement(_core.Button, {
      style: {
        marginLeft: "0px",
        marginRight: "2px"
      },
      onClick: readAllNotifications,
      minimal: true,
      className: _core.Classes.INTENT_PRIMARY,
      "data-testid": "NotificationsIcon.Toolbar.ReadAll"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        textAlign: "center"
      }
    }, translate("NotificationsIcon.Toolbar.ReadAll", "Mark all as read"))))), /*#__PURE__*/_react["default"].createElement(_NotificationsPanel.NotificationsPanel, null))
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_core.Button, {
    "data-testid": "NotificationsIcon.Button",
    icon: _icons.IconNames.ENVELOPE,
    onClick: function onClick() {
      setOpen(!isOpen);
    },
    style: {
      marginRight: "10px"
    }
  }), unreadCount > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "NotificationsIcon.NewMessage"
  }, /*#__PURE__*/_react["default"].createElement(_reactNotificationBadge["default"], {
    count: unreadCount,
    effect: SCALE_EFFECT,
    style: {
      top: "-39px",
      right: "0px",
      pointerEvents: "none"
    }
  })))));
};